<script lang="ts">
	import md from '$lib/utils/md';
	import { getCopy } from '$lib/lang/copy.svelte';
	import Section from '$lib/components/fragments/Section.svelte';
	import AlcoholChart from '$lib/components/charts/Alcohol.svelte';
	import Headline from '$lib/components/fragments/Headline.svelte';
	import Callout from '$lib/components/fragments/Callout.svelte';

	const copy = $derived(getCopy().alcohol);
</script>

<Section id="alcohol" class="overflow-hidden bg-white text-black">
	<div class="content-well-sm">
		<Headline overline={copy.overline} title={copy.title} />
		<div class="body-1 mt-10">{@html md(copy.copy_before)}</div>
	</div>

	<AlcoholChart />

	<div class="content-well-sm">
		<div class="body-1">{@html md(copy.copy_after)}</div>
	</div>

	<Callout
		class="pt-2"
		image={{
			src: 'alcohol.webp',
			alt: copy.callout.alt,
			classes: 'max-w-[150px] md:max-w-[220px]'
		}}
	>
		<div class="callout-content heading-4 text-blue-dark">
			{@html md(copy.callout.text)}
		</div>
	</Callout>
</Section>

<style lang="postcss">
	@reference '$lib/styles/app.css';

	.callout-content {
		:global(span) {
			@apply text-blue-light;
		}
	}
</style>
